export default Object.freeze({
  MediumGray: 'mediumGray',
  Brown: 'cashmere',
  GreenLight: 'celadon',
  Purple: 'frenchLilac',
  Orange: 'tacao',
  Yellow: 'sweetCorn',
  Rose: 'pippin',
});
